import {
  CREATE_DEAL_SUCCESS,
  DELETE_DEAL,
  DELETE_DEAL_FAIL,
  DELETE_DEAL_SUCCESS,
  DELETE_DEALS_SUCCESS,
  ESearchFilter,
  GET_DEALS,
  GET_DEALS_FAIL,
  GET_DEALS_SUCCESS,
  IDeal,
  IDealState,
  SAVE_DEAL,
  SAVE_DEAL_FAIL,
  SAVE_DEAL_SUCCESS,
  SET_DEAL_SEARCH_FILTER,
  SET_DEAL_SEARCH_KEYWORD,
  SET_DEAL_SEARCH_STATUS_FILTER,
} from 'store/deals/types';

const initialState: IDealState = {
  loading: false,
  error: null,
  data: [],
  searchFilter: ESearchFilter.ALL,
  searchKeyword: '',
  statusFilter: 'all',
};

interface IActionCreateDealSuccess {
  type: typeof CREATE_DEAL_SUCCESS;
  deal: IDeal;
}

interface IActionDeleteDeal {
  type: typeof DELETE_DEAL;
}

interface IActionDeleteDealFail {
  type: typeof DELETE_DEAL_FAIL;
  error: Error;
}

interface IActionDeleteDealSuccess {
  type: typeof DELETE_DEAL_SUCCESS;
  id: string;
}

interface IActionDeleteDealsSuccess {
  type: typeof DELETE_DEALS_SUCCESS;
  ids: string[];
}

interface IActionGetDeals {
  type: typeof GET_DEALS;
}

interface IActionGetDealsFail {
  type: typeof GET_DEALS_FAIL;
  error: Error;
}

interface IActionGetDealsSuccess {
  type: typeof GET_DEALS_SUCCESS;
  deals: IDeal[];
}

interface IActionSaveNewDeal {
  type: typeof SAVE_DEAL;
}

interface IActionSaveNewDealFail {
  type: typeof SAVE_DEAL_FAIL;
  error: Error;
}

interface IActionSaveNewDealSuccess {
  type: typeof SAVE_DEAL_SUCCESS;
  deal: IDeal;
}

interface IActionUpdateSearchFilter {
  type: typeof SET_DEAL_SEARCH_FILTER;
  searchFilter: ESearchFilter;
}

interface IActionUpdateSearchKeyword {
  type: typeof SET_DEAL_SEARCH_KEYWORD;
  searchKeyword: string;
}

interface IActionUpdateSearchStatusFilter {
  type: typeof SET_DEAL_SEARCH_STATUS_FILTER;
  statusFilter: string;
}

type TAction =
  | IActionCreateDealSuccess
  | IActionDeleteDeal
  | IActionDeleteDealFail
  | IActionDeleteDealSuccess
  | IActionDeleteDealsSuccess
  | IActionGetDeals
  | IActionGetDealsFail
  | IActionGetDealsSuccess
  | IActionSaveNewDeal
  | IActionSaveNewDealFail
  | IActionSaveNewDealSuccess
  | IActionUpdateSearchFilter
  | IActionUpdateSearchKeyword
  | IActionUpdateSearchStatusFilter;

function reducer(state = initialState, action: TAction) {
  switch (action.type) {
    case CREATE_DEAL_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: [...state.data, action.deal],
      };
    }

    case GET_DEALS:
    case DELETE_DEAL:
    case SAVE_DEAL: {
      return {
        ...state,
        error: null,
        loading: true,
      };
    }

    case GET_DEALS_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.deals,
      };
    }

    case GET_DEALS_FAIL:
    case SAVE_DEAL_FAIL:
    case DELETE_DEAL_FAIL: {
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    }

    case SAVE_DEAL_SUCCESS: {
      const updatedDeals = state.data.map(deal => {
        if (deal.id === action.deal.id) {
          return action.deal;
        }
        return deal;
      });

      return {
        ...state,
        loading: false,
        data: updatedDeals,
      };
    }

    case DELETE_DEAL_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: state.data.filter(deal => deal.id !== action.id),
      };
    }

    case DELETE_DEALS_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: state.data.filter(deal => {
          if (!deal.id) {
            return null;
          }
          return action.ids.includes(deal.id) ? null : deal;
        }),
      };
    }

    case SET_DEAL_SEARCH_KEYWORD: {
      return {
        ...state,
        searchKeyword: action.searchKeyword,
      };
    }

    case SET_DEAL_SEARCH_FILTER: {
      return {
        ...state,
        searchFilter: action.searchFilter,
      };
    }
    case SET_DEAL_SEARCH_STATUS_FILTER: {
      return {
        ...state,
        statusFilter: action.statusFilter,
      };
    }

    default: {
      return state;
    }
  }
}

export default reducer;
